import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  Box,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  IconButton,
  Pagination,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { IMAGE_URL } from "network";
import {
  useBeauticianDetialsMutation,
  useUserBookingDetailsMutation,
} from "slices/beautyApp/beauticianSlice";
import { TextField, InputAdornment } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

import { useBeauticanEarningDeatilsMutation } from "slices/beautyApp/beauticianSlice";
import { order } from "@mui/system";

const STATIC_USER_ORDERS = [
  {
    _id: "U1001",
    createdAt: "2025-01-04",
    items: [{ itemModel: "Hair Cut" }],
    totalAmount: 250,
    orderStatus: "pending",
  },
  {
    _id: "U1002",
    createdAt: "2025-01-03",
    items: [{ itemModel: "Facial" }],
    totalAmount: 550,
    orderStatus: "processing",
  },
  {
    _id: "U1003",
    createdAt: "2025-01-01",
    items: [{ itemModel: "Massage" }],
    totalAmount: 750,
    orderStatus: "pending",
  },
];

function User({ data, type, open, id, onClose }) {
  const [parentTab, setParentTab] = useState(0);
  const [childTab, setChildTab] = useState(0);
  const [page, setPage] = useState(1);

  const ParentTabs = ["Beauty", "E-Commerce"];
  const limit = 10;

  const parentTabs =
    type === "beautician" ? ["Bookings", "Earnings"] : ["Orders"];

  const bookingChildTabs = ["processing", "shipped", "delivered", "cancelled"];
  const userChildTabs = ["beauty", "e-commerce"];
  const [search, setSearch] = useState("");
  const EaringChildTabs = ["Processing", "complete"];

  const [beauticianDetial, { data: BeauticianData, isLoading }] =
    useBeauticianDetialsMutation();
  // console.log("show deatitican details --->", BeauticianData);
  const address = BeauticianData?.data?.[0]?.address;
  const [getUserOrder, { data: Orders, isLoading: IsUserLoading }] =
    useUserBookingDetailsMutation();
  const [getBeauticianEarning, { data: BeauticianEarning, isLoad }] =
    useBeauticanEarningDeatilsMutation();
  // console.log("show beautican earing details----->", BeauticianEarning);

  // console.log("show user ddetailsssssss ordersssss ->>>>>>><<<<<<<", Orders);

  // console.log("show data from imgae profile--->", data);
  console.log(`show data from imgae profile--->", ${IMAGE_URL}${data?.image}`);

  useEffect(() => {
    if (type === "beautician" && open && id && parentTab === 0) {
      beauticianDetial({
        beauticanId: id,
        page,
        limit,
        search,
        status: bookingChildTabs[childTab],
      });
    }
    if (type === "beautician" && open && id && parentTab === 1) {
      getBeauticianEarning({
        beauticianId: id,
        search,
        page,
        limit,
      });
    } else if (type === "user" && open && id && parentTab === 0) {
      const orderType = ParentTabs[parentTab].toLowerCase();
      getUserOrder({
        userId: id,
        orderType: userChildTabs[childTab],
        // orderType: orderType,
        search,
        page,
        limit,
      });
    }
  }, [page, childTab, type, open, id, parentTab, search]);

  const filteredUserOrders = STATIC_USER_ORDERS.filter(
    (x) => x.orderStatus === userChildTabs[childTab]
  );

  const handleParentTab = (_, v) => {
    setParentTab(v);
    setChildTab(0);

    setPage(1);
  };

  const handleChildTab = (_, v) => {
    setChildTab(v);
    setPage(1);
  };

  const handlePageChange = (_, newPage) => setPage(newPage);

  if (!data) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      sx={{
        "& .MuiDialog-container .MuiPaper-root": {
          width: "100% !important",
          maxWidth: "100% !important",
          borderRadius: "20px",
          padding: "20px",
        },
      }}
    >
      {/* CLOSE BUTTON */}
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", top: 8, right: 8, color: "#555" }}
      >
        {/* <CancelIcon fontSize="large" /> */}
        <CancelIcon fontSize="large" htmlColor="#555" />
      </IconButton>

      {/* TITLE */}
      <DialogTitle
        sx={{ fontWeight: 700, borderBottom: "1px solid #ddd", mb: 1 }}
      >
        {type === "beautician" ? "Beautician Profile" : "User Profile"}
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {/* PROFILE SECTION */}
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                width: "100%",
                height: 220,
                borderRadius: 2,
                boxShadow: 2,
                overflow: "hidden", // important so image doesn't overflow
              }}
            >
              <img
                src={
                  data?.image ? `${IMAGE_URL}${data.image}` : "/no-image.jpg"
                }
                alt="User"
                crossorigin="anonymous"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={8}>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              fontWeight={500}
            >
              {data?.name || "--"}
            </Typography>
            {/* {beau} */}
            <Typography
              variant="subtitle2"
              color="textSecondary"
              fontWeight={500}
            >
              {data?.email || "No Email"}
            </Typography>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              fontWeight={500}
            >
              📱 {data?.mobile || "--"}
            </Typography>

            {type === "beautician" && (
              <>
                <Typography color="primary" mt={1.5} fontWeight={500}>
                  ₹ {data?.perMinutCharges}/min
                </Typography>

                <Box
                  sx={{
                    width: "auto",
                    // mb: 2,
                    gap: 2,
                    display: "flex",
                    justifyContent: "",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    fontWeight={500}
                  >
                    Assigned Locations
                  </Typography>
                  {BeauticianData?.data && BeauticianData.data.length > 0 && (
                    <Typography variant="body2" color="text.secondary">
                      {BeauticianData.data
                        .map((item) => item.address?.area)
                        .filter(Boolean)
                        .join(", ")}
                    </Typography>
                  )}
                </Box>

                <Box
                  sx={{
                    width: "auto",
                    // mb: 2,
                    gap: 2,
                    display: "flex",
                    justifyContent: "",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    fontWeight={500}
                  >
                    House No
                  </Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    {BeauticianData?.data?.[0]?.address.houseNo}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "auto",
                    // mb: 2,
                    gap: 2,
                    display: "flex",
                    justifyContent: "",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    fontWeight={500}
                  >
                    Adress
                  </Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    {BeauticianData?.data?.[0]?.address.fullAddress}
                  </Typography>
                </Box>
              </>
            )}
          </Grid>
        </Grid>

        <Box sx={{ height: "1px", backgroundColor: "#e0e0e0", my: 3 }} />

        {/* PARENT TABS  */}
        <Tabs value={parentTab} onChange={handleParentTab}>
          {parentTabs.map((t, i) => (
            <Tab label={t} key={i} />
          ))}
        </Tabs>

        {type === "beautician" && parentTab === 0 && (
          <Tabs
            value={childTab}
            onChange={handleChildTab}
            variant="fullWidth"
            sx={{ borderBottom: "1px solid #ddd", mt: 1 }}
          >
            {bookingChildTabs.map((t, i) => (
              <Tab key={i} label={t} />
            ))}
          </Tabs>
        )}

        {type === "user" && parentTab === 0 && (
          <Tabs
            value={childTab}
            onChange={handleChildTab}
            variant="fullWidth"
            sx={{ borderBottom: "1px solid #ddd", mt: 1 }}
          >
            {userChildTabs.map((t, i) => (
              <Tab key={i} label={t} />
            ))}
          </Tabs>
        )}

        <Box sx={{ width: "100%", mt: 1 }}>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              maxWidth: "100%",
              overflowX: "auto",
              boxShadow: "none",
            }}
          >
            <Box
              sx={{
                width: "auto",
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="subtitle2" fontWeight={600}>
                {/* `Bookings {BeauticianData.length}`` */}
                {/* {type === "beautician" ? `Bookings (${BeauticianData?.data?.length || 0})` :
                  `Orders (${Orders?.data?.length || 0})`
                } */}
                {type === "beautician" && parentTab === 0
                  ? `Bookings (${BeauticianData?.data?.length || 0})`
                  : type === "beautician" && parentTab === 1
                  ? `Earnings (${BeauticianEarning?.data?.length || 0})`
                  : `Orders (${Orders?.data?.length || 0})`}
              </Typography>
              <TextField
                size="small"
                variant="standard"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{
                  width: 200,
                  "& .MuiInput-underline:before, & .MuiInput-underline:after": {
                    borderBottom: "none",
                  },
                  "& input": {
                    padding: "4px 8px",
                    fontSize: "0.875rem",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Table sx={{ width: "100%" }}>
              {/* BEAUTICIAN HEADER */}
              {type === "beautician" && parentTab === 0 && (
                <TableHead sx={{ display: "table-header-group !important" }}>
                  <TableRow>
                    {[
                      "ID",
                      "Date",
                      "Service",
                      "Full Address",
                      "Amount",
                      "Status",
                    ].map((h) => (
                      <TableCell
                        key={h}
                        sx={{ fontWeight: 600, backgroundColor: "#f5f5f5" }}
                        align="center"
                        width="20%"
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              )}
              {type === "beautician" && parentTab === 1 && (
                <TableHead sx={{ display: "table-header-group !important" }}>
                  <TableRow>
                    {[
                      "Id",
                      "Date",
                      "FromUser",
                      "To Name",

                      "Status",

                      "Amount",
                      "currency",
                      "NetAmount",
                      "transactionFee",
                      "Type",
                    ].map((h) => (
                      <TableCell
                        key={h}
                        sx={{ fontWeight: 600, backgroundColor: "#f5f5f5" }}
                        align="center"
                        width="20%"
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              )}
              {type === "user" && parentTab === 0 && (
                <TableHead sx={{ display: "table-header-group !important" }}>
                  <TableRow>
                    {[
                      "ID",
                      "Date",
                      "Service",
                      "Full Address",
                      "Amount",
                      "Quantity",
                      "Status",
                      "Payment Status",
                    ].map((h) => (
                      <TableCell
                        key={h}
                        sx={{
                          fontWeight: 600,
                          backgroundColor: "#f5f5f5",
                          width: "100%",
                        }}
                        align="center"
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              )}

              {/* USER HEADER */}

              <TableBody>
                {/* BEAUTICIAN ROWS */}
                {type === "beautician" &&
                  parentTab === 0 &&
                  (isLoading ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : BeauticianData?.data?.length > 0 ? (
                    BeauticianData.data.map((row, i) => (
                      <TableRow key={i} hover>
                        <TableCell align="center">{row._id}</TableCell>
                        <TableCell align="center">
                          {new Date(row.createdAt).toLocaleDateString()}
                        </TableCell>
                        <TableCell align="center">
                          {row.items?.map((x) => x.itemModel).join(", ")}
                        </TableCell>
                        <TableCell align="center">
                          {row.address?.fullAddress}
                        </TableCell>
                        <TableCell align="center">₹{row.totalAmount}</TableCell>
                        <TableCell align="center">{row.orderStatus}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No data
                      </TableCell>
                    </TableRow>
                  ))}

                {type === "beautician" &&
                  parentTab === 1 &&
                  (isLoad ? (
                    <TableRow>
                      <TableCell colspan={6} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : BeauticianEarning?.data?.length > 0 ? (
                    BeauticianEarning.data.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell>{row._id}</TableCell>
                        <TableCell>
                          {new Date(row.createdAt).toLocaleDateString()}
                        </TableCell>
                        <TableCell>{row.fromUserId.name}</TableCell>
                        <TableCell>{row.toUserId.name}</TableCell>
                        {/* <TableCell>
                            {row.toUserId.mobile}
                          </TableCell> */}
                        <TableCell>{row.status}</TableCell>
                        <TableCell>{row.amount.toFixed(2)}</TableCell>
                        <TableCell>{row.currency}</TableCell>
                        <TableCell>{row.netAmount.toFixed(2)}</TableCell>
                        <TableCell>{row.transactionFee}</TableCell>
                        <TableCell>{row.type}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No Data
                      </TableCell>
                    </TableRow>
                  ))}

                {type === "user" &&
                  (IsUserLoading ? (
                    <TableRow>
                      <TableCell colspan={6} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : Orders && Orders.data && Orders.data.length > 0 ? (
                    Orders.data.map((row, i) => (
                      <TableRow key={row._id || i} hover>
                        {/* ID */}
                        <TableCell align="center">{row._id}</TableCell>

                        {/* DATE */}
                        <TableCell align="center">
                          {row.bookingDate
                            ? new Date(row.bookingDate).toLocaleDateString()
                            : row.createdAt
                            ? new Date(row.createdAt).toLocaleDateString()
                            : "-"}
                        </TableCell>

                        {/* SERVICE (itemType or itemModel) */}
                        <TableCell align="center">
                          {row.items
                            ?.map((x) => x.itemType || x.itemModel)
                            .join(", ") || "-"}
                        </TableCell>

                        {/* FULL ADDRESS */}
                        <TableCell align="center">
                          {row.address?.fullAddress || "-"}
                        </TableCell>

                        {/* AMOUNT */}
                        <TableCell align="center">
                          ₹{row.totalAmount ?? "-"}
                        </TableCell>

                        {/* QUANTITY */}
                        <TableCell align="center">
                          {row.items?.map((x) => x.quantity).join(", ") || "-"}
                        </TableCell>

                        {/* STATUS */}
                        <TableCell align="center">
                          {row.orderStatus || "-"}
                        </TableCell>

                        {/* PAYMENT STATUS */}
                        <TableCell align="center">
                          {row.paymentStatus || "-"}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      {/* colSpan must match number of columns (8) */}
                      <TableCell colSpan={8} align="center">
                        No orders found
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* PAGINATION */}
          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination count={1} page={page} onChange={handlePageChange} />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default User;
